export class UnknownEnumValue extends Error {
	constructor (name: string, value: string|number) {
		const msg = `Unknown ${name} value ${value}`;
		super(msg);
	}
}
